import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { PenTool } from 'lucide-react';

export const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-700 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-white/5 blur-3xl" />
      </div>

      <div className="relative sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-center mb-8">
          <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-white shadow-2xl shadow-black/20 mb-4">
            <PenTool className="h-8 w-8 text-primary-600" />
          </div>
          <h1 className="text-3xl font-bold text-white">BlogWriter AI</h1>
          <p className="text-white/70 mt-1">AI-powered content creation</p>
        </Link>

        {/* Auth Card */}
        <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow-2xl rounded-2xl sm:px-10">
          <Outlet />
        </div>

        {/* Footer */}
        <p className="mt-6 text-center text-sm text-white/60">
          &copy; {new Date().getFullYear()} BlogWriter AI. All rights reserved.
        </p>
      </div>
    </div>
  );
};
